import { makeStyles } from '@material-ui/core/styles'
import themesConfig from 'app/fuse-configs/themesConfig'

const textStyle = {
  color: themesConfig.default.colors['primary-lighter'],
  fontSize: 14,
  lineHeight: '20px',
}

export default makeStyles(() => ({
  tooltip: {
    maxWidth: 340,
  },

  contentWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    maxHeight: 300,
    overflow: 'hidden',
    overflowY: 'auto',

    padding: '8px 15px',
    '& > ul': {
      margin: 0,
      paddingLeft: 20,
    },
  },
  title: {
    ...textStyle,
  },

  message: {
    ...textStyle,
  },
}))
